export const formatDropdownData = (array = []) => {
  if (array.length === 0) {
    return [];
  }
  const result = array.map((obj) => {
    if (obj && typeof obj === 'object') {
      return {
        value: obj._id,
        label: obj.propertyName,
      };
    } else {
      return [];
    }
  });

  return result;
};

export const declarationOptions = [
  {
    value: 'DEFAULT',
    label: 'Default',
  },
  // {
  //   value: 'DEFAULT',
  //   label: 'Minimum',
  // }, Minimum is now rename to deafult
  // {
  //   value: 'WARAKIRRI_DECLARATION',
  //   label: 'General',
  // },
  // {
  //   value: 'AURORA_DECLARATION',
  //   label: 'Dairy',
  // },
  {
    value: 'WARNING',
    label: 'Warning',
  },
  // {
  //   value: 'WEIGHBRIDGE',
  //   label: 'WB',
  // },
  {
    value: 'NONE',
    label: 'None',
  },
];

export function getLabelByKey(key, declarationOption = declarationOptions) {
  for (let option of declarationOption) {
    if (option.value === key) {
      return option.label;
    }
  }
  return '';
}
